// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:31:16

export default {
  "id": "sorting-balls",
  "slug": "sorting-balls",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/aa428e09b0e54951be02842c6ee4dcc1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/aa428e09b0e54951be02842c6ee4dcc1/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sorting Balls",
      "description": "Sorting Balls is a fun and challenging puzzle game where players must sort colored balls into the correct tubes. The goal is to organize all the balls by color using logical thinking and strategic moves. As the levels progress, the puzzles become more complex, requiring careful planning. With simple controls and engaging mechanics, Sorting Balls is perfect for players who enjoy brain-teasing challenges.  ",
      "instructions": "1. Tap a tube to pick up the top ball.  \n2. Tap another tube to place the ball if it matches the top color or if the tube is empty.  \n3. Continue sorting until all balls are grouped by color.  \n4. Plan your moves carefully—some levels require strategy!  \n5. Complete the level to progress to more challenging puzzles.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "ball",
        "colorful",
        "sorting"
      ]
    },
    "zh-CN": {
      "title": "排序球",
      "description": "《排序球》是一款有趣且富有挑战性的益智游戏，玩家需要将彩色球体正确地放入对应的管道中。目标是利用逻辑思维和策略性操作，将所有球体按颜色分类。随着关卡难度提升，谜题变得越来越复杂，需要仔细规划。游戏操作简单，机制吸引人，非常适合喜欢脑力挑战的玩家。",
      "instructions": "1. 点击一个管子以拾起顶部的球。\n2. 点击另一个管子放置球，如果它匹配顶部颜色或管子为空。\n3. 继续分类，直到所有球按颜色分组。\n4. 认真规划你的动作——某些关卡需要策略！\n5. 完成关卡以进入更具挑战性的谜题。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "球",
        "彩色",
        "分类"
      ]
    },
    "zh-TW": {
      "title": "分類球體",
      "description": "Sorting Balls 是一個有趣且挑戰性的益智遊戲，玩家必須將彩色球體分類到正確的管子中。目標是通過邏輯思考和策略性操作，將所有球體按顏色整齊排列。隨著關卡進行，謎題變得更加複雜，需要謹慎的規劃。Sorting Balls 控制簡單且機制吸引人，是適合喜歡挑戰大腦的玩家的完美遊戲。",
      "instructions": "1. 轻觸一條管子以拿起頂端的球。\n2. 轻觸另一條管子將球放置其中，如果球顏色與頂端相匹配或管子為空。\n3. 持續排序，直到所有球都按照顏色分組。\n4. 謹慎規劃你的步驟——某些關卡需要策略！\n5. 完成關卡以進入更具挑戰性的謎題。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "球",
        "顏色",
        "分類"
      ]
    },
    "zh-HK": {
      "title": "分類球體",
      "description": "分類球是款有趣而挑戰性的謎題遊戲，玩家必須將彩色球分類到正確的管內。目標是透過邏輯思考和策略性動作，將所有球按顏色整齊排列。隨著關卡進行，謎題越來越複雜，需要謹慎規劃。 Sorting Balls 操控簡單，機制吸引，適合喜歡挑戰腦力的玩家。",
      "instructions": "1. 轻觸一條管子以拾取頂端的球。\n2. 轻觸另一條管子以放置球，若其顏色與頂端相同或管子為空。\n3. 持續分類，直到所有球均按顏色分組。\n4. 計劃你的動作，有些關卡需要策略！\n5. 完成關卡以進入更具挑戰性的謎題。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "波珠",
        "colorful",
        "分類"
      ]
    },
    "ja": {
      "title": "ボールの並べ替え",
      "description": "Sorting Ballsは、色々なボールを正しい筒に入れる楽しい挑戦的なパズルゲームです。目的は、論理的な思考と戦略的な動きを使って、全てのボールを色ごとに整理することです。レベルが進むにつれて、パズルがより複雑になり、慎重な計画が必要になります。シンプルな操作と魅力的なメカニズムを持つSorting Ballsは、頭を使う挑戦を楽しめるプレイヤーに最適です。",
      "instructions": "1. 管をタップして一番上のボールを選択。\n2. 他の管をタップしてボールを置く（色が一致する場合または管が空の場合）。\n3. 全てのボールが色ごとにグループ化されるまで並べ続ける。\n4. 移動を慎重に計画する（一部のレベルでは戦略が必要です）。\n5. レベルをクリアしてより難しいパズルに進む。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "ボール",
        "カラフル",
        "並べ替え"
      ]
    },
    "ko": {
      "title": "구슬 정리",
      "description": "색상별로 볼을 정리하는 재미있고 도전적인 퍼즐 게임인 Sorting Balls는 플레이어가 색상별로 튜브에 볼을 정리해야 합니다. 목표는 논리적 사고와 전략적인 이동을 사용하여 모든 볼을 색상별로 정리하는 것입니다. 레벨이 진행됨에 따라 퍼즐이 더 복잡해지며, 신중한 계획이 필요합니다. 간단한 조작과 매력적인 기계학적 원리로 Sorting Balls는 뇌를 자극하는 도전을 즐기는 플레이어에게 적합합니다.",
      "instructions": "1. 튜브를 탭하여 가장上面的 볼을 선택하세요.\n2. 다른 튜브를 탭하여 볼을 배치하세요. 튜브의 상단 색상과 일치하거나 튜브가 비어 있다면 됩니다.\n3. 모든 볼이 색상별로 그룹화되도록 계속 정렬하세요.\n4. 움직임을 신중히 계획하세요—일부 레벨은 전략이 필요합니다!\n5. 레벨을 완료하여 더 어려운 퍼즐로 진행하세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "볼",
        "彩色",
        "정리"
      ]
    },
    "fr": {
      "title": "Classer les Billes",
      "description": "Sorting Balls est un jeu de puzzle amusant et stimulant où les joueurs doivent trier des balles colorées dans les bonbonnes correctes. Le but est d'organiser toutes les balles par couleur en utilisant une pensée logique et des mouvements stratégiques. À mesure que les niveaux avancent, les puzzles deviennent plus complexes, nécessitant une planification soigneuse. Avec des commandes simples et des mécanismes captivants, Sorting Balls est parfait pour les joueurs qui aiment les défis intellectuels.",
      "instructions": "1. Tappez sur un tube pour ramasser la balle en haut.\n2. Tappez sur un autre tube pour poser la balle si elle correspond à la couleur en haut ou si le tube est vide.\n3. Continuez à trier jusqu'à ce que toutes les balles soient regroupées par couleur.\n4. Planifiez vos mouvements avec soin — certains niveaux nécessitent une stratégie !\n5. Terminez le niveau pour passer à des puzzles plus difficiles.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "balle",
        "colorée",
        "trier"
      ]
    }
  }
};
